export class SafariAgaveUnsupportedError extends Error {}
export class CookiesDisabledError extends Error {}
